import { CustomException } from "types/customException";
import { replaceKeysInMessage } from "./replaceKeys";

export const tryCatchHandler = async (
	tryFunction: Function,
	genericErrorKey: string,
	genericErrorMessage: string,
	formatMessage: Function
) => {
	try {
		await tryFunction();
	} catch (error) {
		if (error instanceof CustomException) {
			return replaceKeysInMessage(
				formatMessage({
					id: `apiResponse.${error.friendlyKey}`,
					defaultMessage: error.message,
				}),
				error.keys
			);
		} else {
			return formatMessage({
				id: genericErrorKey,
				defaultMessage: genericErrorMessage,
			});
		}
	}
};
